import { useEffect } from "react";

export const useVisibilityPolling = (callback, enabled = true, intervalMs = 5000) => {
  useEffect(() => {
    if (!enabled) return undefined;
    let running = false;
    const run = async () => {
      if (running || document.visibilityState === "hidden") return;
      running = true;
      try { await callback(); }
      finally { running = false; }
    };
    const timer = window.setInterval(run, intervalMs);
    const onVisible = () => { if (document.visibilityState === "visible") run(); };
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [callback, enabled, intervalMs]);
};